'use strict';
const timeFilter = require('../../../../../utils/timestamp-util').timestampToDateFilter;

function parse(reader) {
    reader.readUInt8("version");
    reader.readUInt32LE("data.timestamp", timeFilter);
    reader.readBit(1, "data.din");
    reader.readBit(1, "data.dout");
    const channelCount = reader.readUInt8("data.channel_count");
    for (let i = 1; i <= channelCount; i++) {
        reader.readUInt8(`data.[${i}].channel_id`);
        reader.readUInt8(`data.[${i}].value`);
    }
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/uart/change-report-parser.js